export default "__VITE_ASSET__Cua2FZmJ__"